import { useEffect, useRef } from "react";
import { useRouter } from "@tanstack/react-router";

/** Pushes a page_view to dataLayer on client-side route changes (not the initial load). */
export default function SpaPageViewTracker() {
  const router = useRouter();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    lastPath.current = window.location.pathname;
    return router.subscribe("onResolved", () => {
      const path = window.location.pathname;
      if (path === lastPath.current) return;
      lastPath.current = path;
      // Wait a frame so the new route's <title> is applied.
      setTimeout(() => {
        const w = window as Window & { dataLayer?: unknown[] };
        w.dataLayer = w.dataLayer || [];
        w.dataLayer.push({
          event: "page_view",
          page_path: window.location.pathname,
          page_location: window.location.href,
          page_title: document.title,
        });
      }, 50);
    });
  }, [router]);

  return null;
}
